import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("cwf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchList = (resource) => client.get(`/${resource}`).then((r) => r.data);
export const fetchOne = (resource, id) => client.get(`/${resource}/${id}`).then((r) => r.data);
export const createItem = (resource, data) => client.post(`/${resource}`, data).then((r) => r.data);
export const updateItem = (resource, id, data) => client.put(`/${resource}/${id}`, data).then((r) => r.data);
export const deleteItem = (resource, id) => client.delete(`/${resource}/${id}`).then((r) => r.data);

export const login = (email, password) =>
  client.post(`/auth/login`, { email, password }).then((r) => r.data);
export const logoutApi = () => client.post(`/auth/logout`);
export const getMe = () => client.get(`/auth/me`).then((r) => r.data);

export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post(`/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// Resolve stored relative paths (/api/files/...) to absolute URLs for <img>
export const resolveMediaUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export default client;
